'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var _inherits = require('@babel/runtime/helpers/inherits');

var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');

var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');

var React = require('react');

var FullpageError = require('pobble-components/dist/full-page-error');

var Button = require('pobble-components/dist/button');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var _inherits__default =
/*#__PURE__*/
_interopDefaultLegacy(_inherits);

var _possibleConstructorReturn__default =
/*#__PURE__*/
_interopDefaultLegacy(_possibleConstructorReturn);

var _getPrototypeOf__default =
/*#__PURE__*/
_interopDefaultLegacy(_getPrototypeOf);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var FullpageError__default =
/*#__PURE__*/
_interopDefaultLegacy(FullpageError);

var Button__default =
/*#__PURE__*/
_interopDefaultLegacy(Button);

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn__default["default"](this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ErrorBoundary =
/*#__PURE__*/
function (_Component) {
  _inherits__default["default"](ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck__default["default"](this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass__default["default"](ErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          /*#__PURE__*/
          React__default["default"].createElement(FullpageError__default["default"], {
            monster: "unplug",
            title: "There appears to be a technical error",
            button:
            /*#__PURE__*/
            React__default["default"].createElement(Button__default["default"], {
              action: function action() {
                return window.location.reload();
              },
              tall: true
            }, "Reload the page"),
            desc:
            /*#__PURE__*/
            React__default["default"].createElement(React.Fragment, null, "If this continues to happen, please",
            /*#__PURE__*/
            React__default["default"].createElement("br", null), "contact hello@pobble.com."),
            status: "Oops!"
          })
        );
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error(error); // Update state so the next render will show the fallback UI.

      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(React.Component);

exports.ErrorBoundary = ErrorBoundary;